import { render, staticRenderFns } from "./evaluateList.vue?vue&type=template&id=0ec63402&"
import script from "./evaluateList.vue?vue&type=script&lang=js&"
export * from "./evaluateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports